import stickybits from "stickybits"

export const stickFaq = () => {
  const columnElement = document.querySelector(".referenceSidebarInner")
  // const buttonElement = document.querySelector(".referenceMobileButton")
  if (columnElement) {
    stickybits(columnElement, { stickyBitStickyOffset: 140 })
    // stickybits(buttonElement, {
    //   verticalPosition: "bottom",
    //   stickyBitStickyOffset: 73,
    //   useFixed: true
    //   // scrollEl: ".reference"
    //   // stickyBitStickyOffset: window.innerHeight - 73
    // })
  }
}
